module.exports = __webpack_public_path__ + "static/media/07.b5684d68.mp3";